/* MMS zip-code delivery estimate (TEST theme, added 2026-10-16). Used by snippets/mms-zip-estimate.liquid.
   ESTIMATE ONLY: it does not change the shipping method or cost at checkout.

   =====================================================================================================
   SETTINGS: Damon's numbers. Edit only this block.
   Handling/ship days skip Sat, Sun and the shop holidays; carrier transit days skip Sundays, carrier (federal)
   holidays and Saturdays (Saturday allowed only for Next Day Saturday). Holiday lists: assets/mms-holidays.js
   =====================================================================================================  */
var MMS_ZIP_SETTINGS = {
  cutoffHourET: 14,            /* 2:00 PM ET (14 = 2 PM). In stock: ordered before it on a business day ships the same day.
                                  Vendor/out-of-stock items (2026-10-17): ordered after it, or on a weekend/holiday, counts as
                                  received the next business day, and the lead time starts there. */

  /* Where the item ships from (out-of-stock items match by product vendor or tag). handlingDays = business days until it ships.
     useCutoff: true  -> count from today if before the cutoff on a business day, else from the next business day (all sources since 2026-10-17)
     useCutoff: false -> count from the order day (today), whatever the time
     startNextBizDay: true -> an order placed on a closed day (Sat, Sun, shop holiday) counts as received on the next
                      business day, so the lead time starts there (a Saturday order ships the same day as a Monday order) */
  sources: {
    fairport: { label: 'our Fairport, NY shop',          zip: '14450', handlingDays: 0,  useCutoff: true  }, /* in stock (variant qty > 0) */
    pride:    { label: 'our Fairport, NY shop (Pride Mobility item)',  zip: '14450', handlingDays: 5,  useCutoff: true, startNextBizDay: true, vendors: ['Pride Mobility'], tags: [] },                       /* ~1 week, ships from us */
    golden:   { label: 'Golden Technologies (Wilkes-Barre, PA)',      zip: '18702', handlingDays: 10, useCutoff: true, startNextBizDay: true, vendors: ['Golden Technologies'], tags: [] },                  /* 1112 Inkerman Rd; ~2 weeks */
    nova:     { label: 'Nova Medical (North Aurora, IL)',             zip: '60542', handlingDays: 1,  useCutoff: true, vendors: ['Nova Medical'], tags: [] },                         /* 410 Smoketree Plaza Ste 100; next business day */
    merits:   { label: 'Merits Health Products (Fort Myers, FL)',     zip: '33901', handlingDays: 5,  useCutoff: true, startNextBizDay: true, vendors: ['Merits', 'Merits Health Products', 'Merits Health'], tags: ['Merits', 'Merits Health Products'] } /* 4245 Evans Ave; ~1 week */
  },
  /* Backordered (variant metafield custom.backorder_date set, qty <= 0): handling counts from the release date
     (or today if that date has passed), using the vendor's handlingDays above (Fairport rules if the vendor is unknown). */

  /* Ground transit: straight-line miles between zip3 centroids (assets/mms-zip3.json) -> carrier transit days */
  groundBands: [ [150, 1], [300, 2], [600, 3], [1000, 4], [99999, 5] ],
  methods: {
    ground:    { label: 'Ground',                       transit: 'bands' },
    twoday:    { label: '2-Day',                        transit: 2 },
    nextday:   { label: 'Next Day',                     transit: 1 },
    nextdaysat:{ label: 'Next Day Saturday Delivery',   transit: 1, saturday: true } /* ships Fri -> delivered Sat */
  },
  rangeExtraDays: 0,           /* 0 = show one expected delivery day ("Sat, Oct 17"); 1+ = show a window ending this many carrier days later */

  genericMessage: 'Ships in 5-10 business days',   /* vendor not recognized, or tag "special-order" with no known vendor */
  contactMessage: 'For Alaska, Hawaii, Puerto Rico, U.S. territories and military addresses, please contact us for a delivery estimate.',
  noAreaMessage: 'We couldn\u2019t find that zip code. Please check it or contact us.',
  /* zip3 prefixes that always get contactMessage: PR/VI 006-009, military 090-098/340/962-966, HI 967-968, Guam etc 969, AK 995-999 */
  contactZip3: ['006','007','008','009','090','091','092','093','094','095','096','097','098','340','962','963','964','965','966','967','968','969','995','996','997','998','999']
};
/* ===================================================================================================== */

(function () {
  if (window.__mmsZipEst) return; window.__mmsZipEst = true;
  var S = MMS_ZIP_SETTINGS, LS_ZIP = 'mmsZipEstimateZip', LS_METHOD = 'mmsZipEstimateMethod';
  var DOW = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'], MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function ymd(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }

  /* ---- closed days come from the shared assets/mms-holidays.js (same list as the rental calendar) ---- */
  var H = window.MMSHolidays;
  /* shop (handling/ship) days: no weekends, no shop holidays */
  function isBiz(d) { return H.isShopOpen(d); }
  function addBiz(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (isBiz(d)) n--; } return d; }
  function nextBizOnOrAfter(d) { d = new Date(d); while (!isBiz(d)) d.setDate(d.getDate() + 1); return d; }
  /* carrier delivery days: no Sundays, no carrier (federal) holidays, Saturdays only when allowed */
  function addCarrier(d, n, sat) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (H.isCarrierDay(d, sat)) n--; } return d; }

  /* current date/hour in Eastern Time, as a local midnight Date */
  function nowET() {
    var p = {}; new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' })
      .formatToParts(window.__mmsZipNow || new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { day: new Date(+p.year, +p.month - 1, +p.day), hour: +p.hour };
  }
  function fmt(d) { return DOW[d.getDay()] + ', ' + MON[d.getMonth()] + ' ' + d.getDate(); }

  /* ---- zip3 centroids ---- */
  var zipData = null, zipLoading = null;
  function loadZips(url) {
    if (zipData) return Promise.resolve(zipData);
    if (!zipLoading) zipLoading = fetch(url).then(function (r) { return r.json(); }).then(function (j) { zipData = j; return j; });
    return zipLoading;
  }
  function centroid(zip) {
    var k = zip.slice(0, 3); if (zipData[k]) return zipData[k];
    /* prefix with no ZCTA (PO-box-only areas): use the nearest prefix in the same first two digits */
    for (var i = 1; i < 10; i++) { var a = pad3(+k - i), b = pad3(+k + i); if (a.slice(0, 2) === k.slice(0, 2) && zipData[a]) return zipData[a]; if (b.slice(0, 2) === k.slice(0, 2) && zipData[b]) return zipData[b]; }
    return null;
  }
  function pad3(n) { return ('00' + n).slice(-3); }
  function miles(a, b) {
    var R = 3958.8, r = Math.PI / 180, dLa = (b[0] - a[0]) * r, dLo = (b[1] - a[1]) * r;
    var x = Math.sin(dLa / 2) * Math.sin(dLa / 2) + Math.cos(a[0] * r) * Math.cos(b[0] * r) * Math.sin(dLo / 2) * Math.sin(dLo / 2);
    return 2 * R * Math.asin(Math.sqrt(x));
  }
  function groundDays(mi) { for (var i = 0; i < S.groundBands.length; i++) if (mi < S.groundBands[i][0]) return S.groundBands[i][1]; return S.groundBands[S.groundBands.length - 1][1]; }

  /* ---- which source ships this variant ---- */
  function vendorSource(info) {
    var tags = (info.tags || []).map(function (t) { return t.toLowerCase(); });
    for (var k in S.sources) {
      var s = S.sources[k]; if (k === 'fairport') continue;
      if ((s.vendors || []).some(function (v) { return v.toLowerCase() === (info.vendor || '').toLowerCase(); })) return k;
      if ((s.tags || []).some(function (t) { return tags.indexOf(t.toLowerCase()) !== -1; })) return k;
    }
    return null;
  }
  /* returns {generic:true} or {source:key, startFrom:Date|null, backorder:bool} */
  function plan(info, v) {
    if (!v || !v.a) return { unavailable: true };
    if (v.m === 'shopify' && v.q > 0) return { source: 'fairport' };
    var vs = vendorSource(info);
    if (v.bo) { var p = v.bo.split('/'); return { source: vs || 'fairport', startFrom: new Date(+p[2], +p[0] - 1, +p[1]), backorder: true, rel: v.bo }; }
    if (vs) return { source: vs };
    return { generic: true };
  }
  function shipDate(pl) {
    var src = S.sources[pl.source], n = nowET(), base;
    if (pl.startFrom && pl.startFrom > n.day) {
      base = nextBizOnOrAfter(pl.startFrom);                           /* backordered: count from the release date */
    } else if (src.useCutoff) {
      base = isBiz(n.day) && n.hour < S.cutoffHourET ? n.day : addBiz(n.day, 1);
    } else {
      base = n.day;                                                    /* count business days from the order day */
      if (src.handlingDays === 0 || src.startNextBizDay) base = nextBizOnOrAfter(base); /* closed-day order: start next business day */
    }
    return src.handlingDays ? addBiz(base, src.handlingDays) : base;
  }
  /* transit counts carrier days; Next Day Saturday lets a Saturday count (ship Fri -> Sat) */
  function deliver(ship, transit, sat) { return addCarrier(ship, transit, !!sat); }

  function setup(box) {
    if (box.__init) return; box.__init = true;
    var info = JSON.parse(box.querySelector('[data-zip-info]').textContent);
    var input = box.querySelector('[data-zip-input]'), sel = box.querySelector('[data-zip-method]'), btn = box.querySelector('[data-zip-go]');
    var out = box.querySelector('[data-zip-out]'), shown = false, lastVid = null, lastZip = '';
    /* line item property "Estimated delivery": hidden input tied to the product form (form="product-form-...").
       Enabled only while a dated estimate is shown; disabled inputs are not sent, so no property when skipped. */
    var prop = box.querySelector('[data-zip-prop]');
    function setProp(v) { if (!prop) return; prop.value = v || ''; prop.disabled = !v; }
    setProp('');
    try { if (localStorage.getItem(LS_ZIP)) input.value = localStorage.getItem(LS_ZIP); if (S.methods[localStorage.getItem(LS_METHOD)]) sel.value = localStorage.getItem(LS_METHOD); } catch (e) {}
    function curVariant() {
      var f = document.querySelector('#product-form-' + box.getAttribute('data-section') + ' input[name="id"]') || document.querySelector('form[action*="/cart/add"] input[name="id"]');
      var id = f ? +f.value : +(new URLSearchParams(location.search).get('variant') || 0);
      return info.variants.filter(function (v) { return v.id === id; })[0] || info.variants[0];
    }
    function say(main, sub, cls) {
      out.hidden = false; out.className = 'mms-zip__out' + (cls ? ' mms-zip__out--' + cls : '');
      out.innerHTML = ''; var m = document.createElement('div'); m.className = 'mms-zip__main'; m.textContent = main; out.appendChild(m);
      if (sub) { var s = document.createElement('div'); s.className = 'mms-zip__sub'; s.textContent = sub; out.appendChild(s); }
    }
    function run() {
      var zip = (input.value || '').trim(); setProp('');
      if (!/^\d{5}$/.test(zip)) { say('Please enter a 5-digit zip code.', '', 'warn'); input.focus(); return; }
      try { localStorage.setItem(LS_ZIP, zip); localStorage.setItem(LS_METHOD, sel.value); } catch (e) {}
      var v = curVariant(); lastVid = v && v.id; shown = true; lastZip = zip;
      var pl = plan(info, v), method = S.methods[sel.value] || S.methods.ground;
      box.setAttribute('data-last-source', pl.generic ? 'generic' : pl.unavailable ? 'unavailable' : pl.source);
      if (pl.unavailable) { say('This option is currently unavailable.', ''); return; }
      if (S.contactZip3.indexOf(zip.slice(0, 3)) !== -1) { say(S.contactMessage, '', 'warn'); return; }
      if (pl.generic) { say(S.genericMessage + '.', 'Estimate only. Shipping method and cost are chosen at checkout.'); return; }
      loadZips(box.getAttribute('data-zip3-url')).then(function () {
        var src = S.sources[pl.source], a = centroid(src.zip), b = centroid(zip);
        if (!b) { say(S.noAreaMessage, '', 'warn'); return; }
        var mi = miles(a, b), transit = method.transit === 'bands' ? groundDays(mi) : method.transit;
        var ship = shipDate(pl), d1 = deliver(ship, transit, method.saturday), d2 = addCarrier(d1, S.rangeExtraDays, false);
        var cut = (S.cutoffHourET % 12 || 12) + (S.cutoffHourET < 12 ? ' AM' : ' PM');
        var sub = method.label + ' from ' + src.label + ' \u00b7 ships ' + fmt(ship) + (pl.backorder ? ' (after the ' + pl.rel + ' release)' : '') +
          (pl.backorder ? '' : pl.source === 'fairport' ? ' \u00b7 order by ' + cut + ' ET weekdays to ship same day' :
            ' \u00b7 orders after ' + cut + ' ET, or on weekends/holidays, are processed the next business day') +
          '. Estimate only; shipping method and cost are chosen at checkout.';
        say('Estimated delivery: ' + fmt(d1) + (S.rangeExtraDays > 0 ? ' \u2013 ' + fmt(d2) : ''), sub);
        if ((input.value || '').trim() === zip) setProp(fmt(d1) + (S.rangeExtraDays > 0 ? ' \u2013 ' + fmt(d2) : '') + ' (' + method.label + ' to ' + zip + ')');
        box.setAttribute('data-debug', JSON.stringify({ source: pl.source, miles: Math.round(mi), transit: transit, ship: ymd(ship), d1: ymd(d1), d2: ymd(d2) }));
      }).catch(function () { say(S.noAreaMessage, '', 'warn'); });
    }
    btn.addEventListener('click', function (e) { e.preventDefault(); run(); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); run(); } });
    input.addEventListener('input', function () {
      input.value = input.value.replace(/\D/g, '').slice(0, 5);
      /* zip edited after an estimate: hide the old estimate and drop the property until Estimate is clicked again */
      if (shown && input.value !== lastZip) { shown = false; out.hidden = true; setProp(''); }
    });
    sel.addEventListener('change', function () { try { localStorage.setItem(LS_METHOD, sel.value); } catch (e) {} if (shown) run(); });
    /* re-run when the shopper picks another variant */
    setInterval(function () { if (shown) { var v = curVariant(); if (v && v.id !== lastVid) run(); } }, 800);
  }
  function init() { document.querySelectorAll('[data-mms-zip]').forEach(setup); }
  window.__mmsZipTest = { plan: plan, shipDate: shipDate, deliver: deliver, addBiz: addBiz, isBiz: isBiz, addCarrier: addCarrier };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
